module.exports = __webpack_public_path__ + "fonts/NotoSans-Regular.9ab05beb.ttf";